import React, { useState } from "react";
import { connect } from "react-redux";
import { loadArticles } from "../../../modules/articles";
import useCmsContent from "../../../hooks/useCmsContent";
import ArticleSegment from "../../../ui/Dashboard/ArticleSegment";
import { ButtonPrimary, ButtonTertiary } from "../../Button";
import { Link } from "react-router-dom";
import * as NEWS_ROUTES from "../../../Router/news_routes";

function VenueNewsFeed({
  newsletterLink,
  newsletterTitle,
  newsletterPanelTitle,
}) {
  const content = useCmsContent(4, "created_at");

  const sections = [
    {
      key: "news",
      label: "Venue News",
      route: NEWS_ROUTES.FRONTEND.VENUE_NEWS,
      nothingFound: "No venue news found",
    },
    {
      key: "specialOffers",
      label: "Special Offers",
      route: NEWS_ROUTES.FRONTEND.SPECIAL_OFFERS,
      nothingFound: "No special offers found",
    },
  ];

  const [openKey, setOpenKey] = useState("news");

  const handleToggle = key => {
    setOpenKey(prevKey => (prevKey === key ? null : key));
  };

  return (
    <div key={`newsFeed`} className={"mt-6"}>
      {newsletterLink && newsletterTitle && (
        <div className={"flex flex-col bg-grey p-4"}>
          <div className="flex">
            <div className={"flex-1 pr-4"}>
              <p className={"mb-4 text-base"}>{newsletterPanelTitle}</p>
              <h3 className={"text-bold text-xl"}>{newsletterTitle}</h3>
              <div className="my-2 mt-4">
                <a
                  href={newsletterLink}
                  target={"_blank"}
                  rel={"noreferrer nofollow"}
                >
                  <ButtonPrimary classes={"max-w-full"}>
                    Read more
                  </ButtonPrimary>
                </a>
              </div>
            </div>
            <img src={"/img/agency-dash-newsletter-thumbnail.png"} />
          </div>
        </div>
      )}
      {sections.map(({ key, label, route, nothingFound }) => (
        <div key={key} className="border-b border-grey">
          <div
            className="flex justify-between items-center cursor-pointer py-6"
            onClick={() => handleToggle(key)}
          >
            <h3 className="text-lg font-bold">{label}</h3>
            <span className="text-xl font-bold">
              {openKey === key ? "−" : "+"}
            </span>
          </div>

          {openKey === key && (
            <div
              className={`accordion-content transition-max-height duration-500 ease-in-out overflow-hidden ${
                openKey === key ? "max-h-screen" : "max-h-0"
              }`}
            >
              {content[key] && content[key].length > 0 ? (
                <>
                  {content[key].slice(0, 3).map((item, index) => (
                    <ArticleSegment key={index} item={item} />
                  ))}
                </>
              ) : (
                <div
                  className={
                    "w-full text-center inline-block bg-blue text-white p-4 mt-2 text-lg"
                  }
                >
                  <span>{nothingFound}</span>
                </div>
              )}

              <div className="mb-8 mt-4">
                <ButtonTertiary
                  style={{ width: "inherit" }}
                  classes="text-md font-bold"
                >
                  <Link to={route} className="text-white">
                    View all {label}
                  </Link>
                </ButtonTertiary>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default connect(
  state => ({
    articles: state.articles.articles,
    offers: state.articles.offers,
    articlesLoaded: state.articles.loaded,
    articlesLoading: state.articles.loading,
  }),
  { loadArticles }
)(VenueNewsFeed);
